<template>
  <el-dialog title="选择联系人" :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%">
    <el-form :model="data" :rules="rules" ref="addForm" label-width="100px">
        <el-form-item label="联系人:" prop="contact">
          <el-select v-model="data.contact" placeholder="请选择联系人" clearable style="width:100%">
            <el-option v-for="dict in contactList" :key="dict.id" :label="dict.contactName" :value="dict" />
          </el-select>
          <span>如果无联系人，请<el-button type="text" @click="handleAddBusinessContact">前往添加</el-button></span>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="confirm">确认</el-button>
    </span>
    <AddBusinessContactDialog ref="addBusinessContactDialogRef" @success="refreshContactAndLog"></AddBusinessContactDialog>
  </el-dialog>
</template>

<script>

import AddBusinessContactDialog from "@/views/crm/business/addBusinessContactDialog";
import { queryBusinessContact } from '@/api/crm/business'

export default {
  name: "AddBusinessDialog",
  props: {
  },
  data() {
    return {
      visible: false,
      id: null, // 商机id
      contactList: [], // 商机中的联系人
      rules: {
        contact: [
          {required: true, message: '请选择联系人', trigger: 'change'}
        ],
      },
      data: {
        contact: null,
      }
    };
  },
  components: {
    AddBusinessContactDialog
  },
  watch: {
    visible (val) {
      if (!val) {
          this.resetForm('addForm')
        // this.data.contact = null
      }
    }
  },
  methods: {
    open (id) {
      this.id = id
      this.data.contact = null
      this.visible = true
      this.getContactList() // 获取联系人
    },
    /** 新增按钮操作 */
    handleAddBusinessContact() {
      this.$refs.addBusinessContactDialogRef.open(this.id, null);
    },
    confirm () {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.visible = false
          this.$emit('success', JSON.parse(JSON.stringify(this.data.contact)))
        } else {
          this.msgWarning("请检查必填项");
          return false;
        }
      });
    },
    // 刷新商机联系人
    refreshContactAndLog(){
        this.getContactList()
    },
    getContactList() {
      let param = {
        id: this.id
      }
      this.data.contactId = null
      queryBusinessContact(param).then(response => {
        this.contactList = response.data
      }).catch(error => {
      })
    },
  }
};
</script>
